import { createSelector } from '@reduxjs/toolkit'
import { getStoriesViewState } from '../../getters'

export const selectStoryIndex = createSelector(
  [getStoriesViewState],
  (storyViewState) => {
    if (!storyViewState.story) return []
    if (!storyViewState.story.ids) return []
    return storyViewState.story.ids
  }
)
